module.exports = __webpack_public_path__ + "img/arrow-choice.53e713e0.svg";